import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { SuspenseView } from "../../components/misc/SuspenseView";

const IamModuleRoutes: React.FC = () => {
  const StoresRoutes = lazy(() => import("./StoresRoutes"));

  return (
    <Routes>
      {/* Sections */}
      <Route
        path="stores/*"
        element={
          <SuspenseView>
            <StoresRoutes />
          </SuspenseView>
        }
      ></Route>
    </Routes>
  );
};

export default IamModuleRoutes;
